import(/* webpackMode: "eager" */ "/app/src/app/products/inscribee/page.tsx");
